<template>
  <svg
    aria-hidden="true"
    :width="width"
    :height="height"
    viewBox="0 0 43.56 43.56"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g transform="translate(2, 0)">
      <linearGradient :id="clipPathId" x1="0" x2="100%" y1="0" y2="0">
        <stop :offset="fillGradientOffset" :stop-color="activeColor" :stop-opacity="activeColor" />
        <stop
          :offset="fillGradientOffset"
          :stop-color="inactiveColor"
          :stop-opacity="inactiveColor"
        />
      </linearGradient>

      <polygon
        points="19.8,2.2 6.6,43.56 39.6,17.16 0,17.16 33,43.56"
        :fill="`url(#${clipPathId})`"
      />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'refapp-star-icon',
  props: {
    fillPercentage: {
      type: Number,
      default: 0,
    },
    activeColor: {
      type: String,
      default: '#ffd055',
    },
    inactiveColor: {
      type: String,
      default: '#d8d8d8',
    },
    width: {
      type: [Number, String],
      default: 24,
    },
    height: {
      type: [Number, String],
      default: 24,
    },
  },
  data() {
    return {
      clipPathId: null,
    };
  },
  computed: {
    fillGradientOffset() {
      return `${this.fillPercentage}%`;
    },
  },
  created() {
    this.clipPathId = crypto.randomUUID();
  },
};
</script>
